<template>
  <span
    class="input-warning-text"
    v-show="error.length > 0"
  >
    <base-icon
      iconRef="alert-circle"
      position="left"
    ></base-icon>
    {{error}}
  </span>
</template>

<script>
export default {
  name: "Base-input-warning",
  props: {
    error: {
      default: "",
      type: String
    }
  },
  computed: {
    hasError: function() {
      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/base-components/base-input-warning.vue